import styled from 'styled-components';

export const FormContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.greys.lighter};
`;

export const Header = styled.div`
  height: 48px;
  min-height: 48px;
  width: 100%;
  padding: 0 24px;

  display: flex;
  align-items: center;
  column-gap: 12px;

  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const BackButton = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;

  font: ${({ theme }) => theme.fonts.textBigHeight16};
  color: ${({ theme }) => theme.colors.greys.darkest};
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;

  padding: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  overflow-y: auto;
`;

export const Footer = styled.div`
  height: 64px;
  min-height: 64px;
  width: 100%;
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-top: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const FooterButtons = styled.div`
  display: flex;
  column-gap: 24px;
`;
